// Centralized fixture of locked CoreX waitlist options + copy (WAIT-4A).
// Codes MUST match the WAIT-3A.2 API contract exactly. Do not scatter these.

// Persona multi-select — all seven personas, API codes locked.
export const PERSONA_OPTIONS = [
  { code: "athlete", label: "Athlete" },
  { code: "parent_guardian", label: "Parent / Guardian" },
  { code: "coach", label: "Coach" },
  { code: "team_club", label: "Team / Club" },
  { code: "facility_track", label: "Facility / Track" },
  { code: "sport_org_governing_body", label: "Sport Organization" },
  { code: "other", label: "Other" },
];

// Sport multi-select — ONLY the six approved launch sports are public.
// Cyclocross / Soccer / Hockey / Baseball / Basketball remain in the DB but
// are intentionally hidden from the public launch form.
export const SPORT_OPTIONS = [
  { code: "bmx_racing", label: "BMX Racing" },
  { code: "bmx_freestyle", label: "BMX Freestyle" },
  { code: "mountain_biking", label: "Mountain Biking" },
  { code: "track_cycling", label: "Track Cycling" },
  { code: "road_cycling", label: "Road Cycling" },
  { code: "other", label: "Other" },
];

export const OTHER_CODE = "other";
export const OTHER_TEXT_MAX = 120;

// Locked landing-page copy.
export const COPY = {
  logoAlt: "CoreX Athlete Development",
  brandKicker: "ATHLETE DEVELOPMENT",
  headlineLine1: "BUILT FOR PROGRESSION.",
  headlineLine2: "DESIGNED FOR WHAT\u2019S NEXT.",
  tagline: "Building Better Athletes. Every Day.",
  waitlistHeading: "JOIN THE WAITLIST",
  waitlistSupport: "Be among the first to experience CoreX.",
  personaLabel: "I AM A\u2026",
  personaOtherLabel: "TELL US ABOUT YOUR ROLE",
  sportLabel: "WHICH SPORTS ARE YOU INTERESTED IN?",
  sportOtherLabel: "TELL US WHICH SPORT",
  consent:
    "I consent to receive CoreX launch updates and promotional emails. I can unsubscribe at any time.",
  privacyNoticeLabel: "Waitlist Privacy Notice",
  privacyReassurance:
    "We respect your privacy. No spam. Unsubscribe anytime.",
  submit: "JOIN THE WAITLIST",
  missionKicker: "OUR MISSION",
  mission:
    "Empowering athletes to reach their full potential through structured, measurable, and consistent development.",
  // Typographic bullet separators (\u2022) rather than asterisks.
  footer: "COREX ATHLETE DEVELOPMENT \u2022 PRIVATE LAUNCH \u2022 STAY READY",

  // Options loading / error
  optionsLoading: "Loading waitlist options\u2026",
  optionsError: "Waitlist options could not be loaded. Please try again.",
  tryAgain: "TRY AGAIN",

  // Submission lifecycle
  submitting: "JOINING\u2026",
  successHeading: "YOU\u2019RE ON THE LIST.",
  successMessage: "You\u2019re on the CoreX waitlist.",
  errorHeading: "WE COULDN\u2019T COMPLETE YOUR SIGNUP.",
  errorMessage: "Please try again in a moment.",
  rateLimitMessage: "Too many attempts. Please wait a moment and try again.",
  validationMessage: "Please review your information and try again.",
};
